import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg
    width={props.width}
    style={props.style}
    height={props.width}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${props.className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path style={{fill: '#EE3840'}} 
    d="M445.841,201.423c0,152.012-171.608,292.797-171.608,292.797c-10.027,8.226-26.437,8.226-36.465,0
	c0,0-171.608-140.785-171.608-292.797c0-104.846,84.995-189.84,189.841-189.84S445.841,96.578,445.841,201.423z"/>
    <path style={{fill: '#FFE1D6'}} 
    d="M256.001,296.934c-52.665,0-95.51-42.846-95.51-95.51s42.846-95.51,95.51-95.51
	s95.51,42.846,95.51,95.51S308.664,296.934,256.001,296.934z"/>
    <g>
    <path style={{fill:'#11113F'}} d="M256.001,0C144.935,0,54.576,90.359,54.576,201.424c0,36.373,9.386,74.987,27.896,114.767
    c14.616,31.409,34.94,63.649,60.411,95.826c43.178,54.547,85.749,89.691,87.54,91.16c7.171,5.883,16.375,8.825,25.579,8.825
    c9.204,0,18.407-2.942,25.579-8.825c1.791-1.47,44.361-36.613,87.539-91.16c25.47-32.176,45.795-64.416,60.411-95.826
    c18.51-39.78,27.896-78.392,27.896-114.767C457.424,90.359,367.065,0,256.001,0z M351.247,397.268
    c-41.647,52.697-83.942,87.653-84.361,87.997c-5.799,4.758-15.972,4.757-21.768,0.002c-0.422-0.346-42.716-35.302-84.363-87.999
    c-37.869-47.918-83.012-120.791-83.012-195.844c-0.001-98.292,79.965-178.258,178.257-178.258s178.258,79.966,178.258,178.258
    C434.258,276.476,389.116,349.35,351.247,397.268z"/>
    <path style={{fill:'#11113F'}} d="M256.001,94.331c-59.051,0-107.093,48.042-107.093,107.094c0,59.051,48.042,107.093,107.093,107.093
    s107.093-48.042,107.093-107.093C363.093,142.373,315.051,94.331,256.001,94.331z M256.001,285.351
    c-46.278,0-83.927-37.649-83.927-83.927s37.649-83.928,83.927-83.928s83.927,37.65,83.927,83.928S302.277,285.351,256.001,285.351z
    "/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
  </svg>  
);

export default Icon;